var _mask, _g, _path, _mask2, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCustomRole(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "Custom_-_Role_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 7,
    height: 8
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M5 5h7v7.5H5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Custom_-_Role_svg__a)",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 7.5,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 12.5,
    r: 3
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M.5.5h12v3H.5z"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "Custom_-_Role_svg__b",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 13,
    height: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 0v5H3v5H0V0h13z",
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Custom_-_Role_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M.5.5h12v9H.5z"
  }))));
}

export default SvgCustomRole;